/* tslint:disable */
import {
  ProductCategory,
  ProductUom
} from '../index';

declare var Object: any;
export interface ProductInterface {
  "id"?: number;
  "name": string;
  "code"?: string;
  "uom_id": number;
  "uom_po_id": number;
  "categ_id": number;
  "price"?: number;
  "list_price"?: number;
  "standard_price"?: number;
  "min_density"?: number;
  "max_density"?: number;
  "min_fluency"?: number;
  "max_fluency"?: number;
  "min_volatile"?: number;
  "max_volatile"?: number;
  "quality_valid_products_ids"?: number;
  category?: ProductCategory;
  uom?: ProductUom;
  uom_po?: ProductUom;
}

export class Product implements ProductInterface {
  "id": number;
  "name": string;
  "code": string;
  "uom_id": number;
  "uom_po_id": number;
  "categ_id": number;
  "price": number;
  "list_price": number;
  "standard_price": number;
  "min_density": number;
  "max_density": number;
  "min_fluency": number;
  "max_fluency": number;
  "min_volatile": number;
  "max_volatile": number;
  "quality_valid_products_ids": number;
  category: ProductCategory;
  uom: ProductUom;
  uom_po: ProductUom;
  constructor(data?: ProductInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Product`.
   */
  public static getModelName() {
    return "Product";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Product for dynamic purposes.
  **/
  public static factory(data: ProductInterface): Product{
    return new Product(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Product',
      plural: 'Products',
      path: 'Products',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
        "name": {
          name: 'name',
          type: 'string'
        },
        "code": {
          name: 'code',
          type: 'string'
        },
        "uom_id": {
          name: 'uom_id',
          type: 'number'
        },
        "uom_po_id": {
          name: 'uom_po_id',
          type: 'number'
        },
        "categ_id": {
          name: 'categ_id',
          type: 'number'
        },
        "price": {
          name: 'price',
          type: 'number'
        },
        "list_price": {
          name: 'list_price',
          type: 'number'
        },
        "standard_price": {
          name: 'standard_price',
          type: 'number'
        },
        "min_density": {
          name: 'min_density',
          type: 'number'
        },
        "max_density": {
          name: 'max_density',
          type: 'number'
        },
        "min_fluency": {
          name: 'min_fluency',
          type: 'number'
        },
        "max_fluency": {
          name: 'max_fluency',
          type: 'number'
        },
        "min_volatile": {
          name: 'min_volatile',
          type: 'number'
        },
        "max_volatile": {
          name: 'max_volatile',
          type: 'number'
        },
        "quality_valid_products_ids": {
          name: 'quality_valid_products_ids',
          type: 'number'
        },
      },
      relations: {
        category: {
          name: 'category',
          type: 'ProductCategory',
          model: 'ProductCategory',
          relationType: 'belongsTo',
                  keyFrom: 'categ_id',
          keyTo: 'id'
        },
        uom: {
          name: 'uom',
          type: 'ProductUom',
          model: 'ProductUom',
          relationType: 'belongsTo',
                  keyFrom: 'uom_id',
          keyTo: 'id'
        },
        uom_po: {
          name: 'uom_po',
          type: 'ProductUom',
          model: 'ProductUom',
          relationType: 'belongsTo',
                  keyFrom: 'uom_po_id',
          keyTo: 'id'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/sdk/models/Product.ts